export default __webpack_public_path__ + "static/media/img-4.a31875b7.jpg";